import config from '../../config';

export default {
  url: `${config.api.baseURL}/roles`,
  transformer(data) {
    return data;
  }
};



// WEBPACK FOOTER //
// ./src/api/roles/list.js